import { Controller } from "@hotwired/stimulus"

export default class TeachingApplicationsController extends Controller {
  static targets = [
    'destroyCheckbox',
    'destroyButton'
  ];

  connect() {
    this.toggleCheckbox();
  }

  toggleCheckbox() {
    this.destroyButtonTarget.disabled = !this.destroyCheckboxTargets.some(checkbox => checkbox.checked);
  }
}
